/** Prefixo das rotas autenticadas da SPA. */
export const APP = '/app';

/** Junta segmentos ao prefixo /app (ex.: appPath('expenses/new')). */
export function appPath(...segments) {
  const tail = segments.filter(Boolean).join('/');
  return tail ? `${APP}/${tail}` : APP;
}

export const paths = {
  app: APP,
  dashboard: appPath('dashboard'),
  expenses: appPath('expenses'),
  expensesNew: appPath('expenses/new'),
  categories: appPath('categories'),
  category: (id) => appPath(`categories/${id}`),
  budget: appPath('budget'),
  goals: appPath('goals'),
  goalsNew: appPath('goals/new'),
  goal: (goalId) => appPath(`goals/${goalId}`),
  pots: appPath('pots'),
  calendar: appPath('calendar'),
  income: appPath('income'),
  incomeSources: appPath('income/sources'),
  incomeNew: appPath('income/new'),
  incomeRegister: `${appPath('income')}?register=1`,
  emergencyFund: appPath('emergency-fund'),
  emergencyFundWizard: appPath('emergency-fund/wizard'),
  emergencyFundPlano: appPath('emergency-fund/plano'),
  ativos: appPath('ativos'),
  dividas: appPath('dividas'),
  dividasPlan: appPath('dividas/plano'),
  dividasEvaluator: appPath('dividas/avaliador'),
  dividasSimulator: (id) => appPath(`dividas/simulador/${id}`),
  patrimonio: appPath('patrimonio'),
  selfieNew: appPath('selfie/new'),
  selfieResult: (id) => appPath(`selfie/result/${id}`),
  selfieReport: (id) => appPath(`selfie/result/${id}/report`),
  selfies: appPath('selfies'),
  cycleSettings: appPath('ciclo/definicoes'),
  settings: appPath('settings'),
  settingsProfile: appPath('settings/profile'),
  settingsAccount: appPath('settings/account'),
  settingsBudgetMethod: appPath('settings/budget-method'),
  settingsCycleDay: appPath('settings/cycle-day'),
  settingsHelp: appPath('settings/help'),
  settingsDeleteAccount: appPath('settings/delete-account'),
  settingsNotifications: appPath('settings/notifications'),
  settingsReminders: appPath('settings/reminders'),
  settingsAppearance: appPath('settings/appearance'),
  selfieEdit: (id) => appPath(`selfie/${id}/edit`),
  signIn: '/sign-in',
};
